export const useDefaultData = ({ Helpers }) => {

    const {
        getCurrentDate,
        getCurrentStartMonth
    } = Helpers

    const defaultDataModal = {
        open: false,
        titleModal: '',
        componentModal: '',
        dataRequest: {},
    }

    const defaultFilterForm = {
        startDate: getCurrentStartMonth(),
        endDate: getCurrentDate(),
        idcategoria: '',
        currency_type: '',
        idcaja: '',
        movimiento_tipo: ''
    }

    return Object.freeze({
        defaultDataModal,
        defaultFilterForm
    })
}